/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { ConfigService } from './shared/services/config.service';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function getMsalConfig(configService: ConfigService): Configuration {
    const config = configService.getConfig();

    return {
        auth: {
            clientId: config.msalConfig.auth.clientId,
            authority: config.msalConfig.auth.authority,
            knownAuthorities: config.msalConfig.auth.knownAuthorities,
            redirectUri: config.msalConfig.auth.redirectUri,
            postLogoutRedirectUri: config.msalConfig.auth.postLogoutRedirectUri
        },
        cache: {
            cacheLocation: config.msalConfig.cache.cacheLocation as BrowserCacheLocation,
            storeAuthStateInCookie: config.msalConfig.cache.storeAuthStateInCookie || isIE
        },
        system: {
            loggerOptions: {
                loggerCallback: (logLevel, message, containsPii) => {
                    console.log(message);
                },
                logLevel: LogLevel.Info,
                piiLoggingEnabled: false
            }
        }
    };
}

export function getLoginRequest(configService: ConfigService) {
    const config = configService.getConfig();
    return {
        scopes: [...config.loginConfig.scopes]
    };
}

export function getGraphConfig(configService: ConfigService) {
    const config = configService.getConfig();
    return {
        graphMeEndpoint: config.apiConfig.uri,
        graphScopes: config.apiConfig.scopes
    };
}
